import script from "./SaldoBanco.vue?vue&type=script&setup=true&lang=js"
export * from "./SaldoBanco.vue?vue&type=script&setup=true&lang=js"

import "./SaldoBanco.vue?vue&type=style&index=0&id=2256748c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2256748c"]])

export default __exports__